import { Box } from '@mui/material'
import { TONE, WD_STATUS, HOLD_STATUS, WF_STATUS, WF_LEVEL_LABEL, fmtInr } from '../format'

/**
 * The one pill every status in this module renders through — same shape as the
 * v1 All Discrepancies badge (dot + label, 20px radius) so the two screens read
 * as one product while v1 is still around.
 */
export function ToneChip({ tone = 'grey', label, title }) {
  const c = TONE[tone] || TONE.grey
  return (
    <Box
      component='span'
      title={title}
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: '5px',
        px: '9px', py: '3px', borderRadius: '20px',
        fontSize: '11px', fontWeight: 700, letterSpacing: '0.2px', lineHeight: 1.4,
        bgcolor: c.bg, color: c.fg, border: `1px solid ${c.border}`, whiteSpace: 'nowrap',
      }}
    >
      <Box component='span' sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: c.dot, flexShrink: 0 }} />
      {label}
    </Box>
  )
}

export function WdStatusChip({ status }) {
  if (!status) return <Box component='span' sx={{ fontSize: 12, color: 'text.disabled' }}>—</Box>
  const cfg = WD_STATUS[status] || { label: status, tone: 'grey' }
  return <ToneChip tone={cfg.tone} label={cfg.label} title={status} />
}

/** null holdStatus = the row predates the hold model or the flag was off; nothing to show. */
export function HoldChip({ holdStatus, holdAmount }) {
  if (!holdStatus) return null
  const cfg = HOLD_STATUS[holdStatus] || { label: holdStatus, tone: 'grey' }
  const label = holdAmount != null ? `${cfg.label} · ${fmtInr(holdAmount)}` : cfg.label
  return <ToneChip tone={cfg.tone} label={label} title={`Wallet hold: ${holdStatus}`} />
}

export function WfStatusChip({ status }) {
  if (!status) return null
  const cfg = WF_STATUS[status] || { label: status, tone: 'grey' }
  return <ToneChip tone={cfg.tone} label={cfg.label} title={status} />
}

export function LevelChip({ level }) {
  if (!level) return null
  return <ToneChip tone={level === 'SKU' ? 'info' : level === 'COMBO' ? 'purple' : 'grey'} label={WF_LEVEL_LABEL[level] || level} />
}
